import React from "react";
import DateFilter from "../modules/my_tickets/DateFilter";
import TicketsOverall from "../modules/my_tickets/TicketsOverall";
import TicketsToday from "../modules/my_tickets/TicketsToday";
import NewTicketsTable from 'modules/my_tickets/NewTicketTable';
import { useEffect, useState } from "react";
import useAllTicketStore from "modules/my_tickets/all_tickets/store";
import "../../src/main.css";
import AllInputSearch from "modules/my_tickets/AllInputSearch";
import ChartOptions from "modules/my_tickets/Graph";
import CardTabs from "modules/common/card-tabs/CardTabs";
import InputData from "modules/my_tickets/InputData";
import { removeSpaces } from "modules/utilities/utility";

import moment from "moment";
import useAssignedStore from 'modules/my_tickets/assigned_tickets/store';
import useInternalTicketStore from 'modules/my_tickets/internal_tickets/store';
import { useOrderSearchForTicket } from "modules/CreateTicket/store";

const TicketTab = ({ tab }) => {
    const {
        allTicketData,
        rowChecked,
        allTicketLoading,
        fetchAllTicketData,
        fetchAllTicketStats,
        allTicketStats,
        allTicketDownload,
        allTicketError
    } = useAllTicketStore();
    const {
        assignedTicketData,
        assignedTicketLoading,
        assignedTicketError,
        fetchAssignedData,
        fetchAssignedTicketStats,
        assignedTicketStats,
        assignedTicketDownloads
    } = useAssignedStore();
    const {
        internalTicketData,
        fetchInternalTickets,
        internalTicketLoading,
        internalTicketError,
    } = useInternalTicketStore();
    const {
        fetchAllCrmCategories,
        allCrmCategories
    } = useOrderSearchForTicket();

    const [ticketData, setTicketData] = useState([]);
    const [totalPage, setTotalPage] = useState(1);
    const [newPage, setNewPage] = useState(1);
    const [query, setQuery] = useState('');
    const [startDateFilter, setStartDateFilter] = useState("");
    const [endDateFilter, setEndDateFilter] = useState("");
    const [selectedStatus, setSelectedStatus] = useState(null);
    const [selectedCategory, setSelectedCategory] = useState(null);
    const [selectedSubCategory, setSelectedSubCategory] = useState(null);
    const [selectedPriority, setSelectedPriority] = useState(null);
    const [selectedAssignee, setSelectedAssignee] = useState(null);
    const [doctorCallAttempt, setDoctorCallAttempt] = useState(false);
    const [refresh, setRefresh] = useState(false);
    const [sortByCreatedAt, setSortByCreatedAt] = useState(0);
    const [sortByUpdatedAt, setSortByUpdatedAt] = useState(0);
    const startDate = moment().startOf('day').format('YYYY-MM-DD');
    const endDate = moment().endOf('day').subtract(7, 'days').format('YYYY-MM-DD');
    const startTicketDate = endDate;
    const endTicketDate = startDate;
    let inputQuery;

    const ticketsFunctions = {
        assigned: {
            getTicket: fetchAssignedData,
            ticketData: assignedTicketData,
            getStats: fetchAssignedTicketStats,
            statsData: assignedTicketStats,
            loading: assignedTicketLoading,
            downloadData: assignedTicketDownloads,
            error: assignedTicketError
        },
        all: {
            getTicket: fetchAllTicketData,
            ticketData: allTicketData,
            getStats: fetchAllTicketStats,
            statsData: allTicketStats,
            loading: allTicketLoading,
            downloadData: allTicketDownload,
            error: allTicketError
        },
        internalTickets: {
            getTicket: fetchInternalTickets,
            ticketData: internalTicketData,
            getStats: fetchAllTicketStats,
            statsData: internalTicketData,
            loading: internalTicketLoading,
            downloadData: allTicketDownload,
            error: internalTicketError
        }
    }
    const selectedTab = ticketsFunctions[tab];

    useEffect(() => { _.isEmpty(allCrmCategories) && fetchAllCrmCategories() }, []);

    useEffect(() => {
        if (selectedTab?.ticketData && ['assigned', 'all', 'internalTickets'].includes(tab)) {
            const newTicketData = selectedTab?.ticketData?.data;
            setTicketData(newTicketData);
            const pageNumbers = selectedTab?.ticketData?.row_count;
            setTotalPage(Math.floor(pageNumbers / 10) + (Math.ceil(pageNumbers / 10) - Math.floor(pageNumbers / 10) > 0 ? 1 : 0))
        }
    }, [selectedTab?.ticketData, tab]);

    useEffect(() => {
        if (['assigned', 'all', 'internalTickets'].includes(tab)) {
            if (startDateFilter === "" || endDateFilter === "") {
                selectedTab?.getStats(startTicketDate, endTicketDate, query);
                selectedTab?.getTicket(startTicketDate, endTicketDate, newPage, query);
            } else if (startDateFilter && endDateFilter) {
                selectedTab?.getStats(startDateFilter, endDateFilter, query);
                selectedTab?.getTicket(startDateFilter, endDateFilter, newPage, query);
            }
        }

    }, [startDateFilter, endDateFilter, startTicketDate, endTicketDate, refresh, tab, newPage, query]);

    const handleFilterClick = () => {
        let filter = '';
        let selectedStatusData = selectedStatus;
        let selectedCategoryData = selectedCategory;
        let selectedSubCategoryData = selectedSubCategory;
        let selectedPriorityData = selectedPriority?.map((item) => item.value);
        let selectedAssigneeData = selectedAssignee;
        
        if (selectedStatus && selectedStatus.length > 0) {
            const status = selectedStatusData.join(',');
            filter += `statusCode=${status}`;
        }
        
        if (doctorCallAttempt) {
            filter += `&doctorCallAttempt=${doctorCallAttempt}`;
        }

        if (selectedCategoryData && selectedCategoryData.length > 0) {
            const category = selectedCategoryData.join(',');
            filter += `&category=${category}`;
        }

        if (selectedSubCategoryData && selectedSubCategoryData.length > 0) {
            filter += `&subCategory=${selectedSubCategoryData.join(',')}`;
        }

        if (selectedPriorityData && selectedPriorityData.length > 0) {
            filter += `&priority=${selectedPriorityData.join(',')}`;
        }

        if (selectedAssigneeData && selectedAssigneeData.length > 0) {
            filter += `&assignee=${selectedAssigneeData.join(',')}`;
        }

        if (sortByCreatedAt) {
            filter += filter.length > 0 ? `&sortByCreatedAt=${sortByCreatedAt}` : `sortByCreatedAt=${sortByCreatedAt}`
        }

        if (sortByUpdatedAt) {
            filter += filter.length > 0 ? `&sortByUpdatedAt=${sortByUpdatedAt}` : `sortByUpdatedAt=${sortByUpdatedAt}`;
        }
        if (inputQuery && inputQuery.length > 0) {
            const searchBy = inputQuery;
            const searchQuery = searchBy.startsWith('#') ? searchBy.replace('#', 'oid') : searchBy;
            filter += filter.length > 0 ? `&searchBy=${searchQuery}` : `searchBy=${searchQuery}`;
        }
        setQuery(filter);
        setNewPage(1);
    };

    const handleSort = (col) => {
        const sort = (sort) => {
            if (sort === 1)
                return -1;
            else if (sort === -1) {
                return 0;
            }
            else return 1
        }
        if (col === 'sortByCreatedAt') {
            setSortByCreatedAt(sort)
            setSortByUpdatedAt(0)
        } else {
            setSortByUpdatedAt(sort)
            setSortByCreatedAt(0);
        }
        handleFilterClick()
    }


    const handleSearch = (query) => {
        inputQuery = removeSpaces(query);
        handleFilterClick();
    };

    const handleChange = (value) => {
        if (value === '') {
            handleFilterClick();
        }
    };

    const handleDownload = async () => {
        let dateStart, dateEnd;
        if (startDateFilter === "" || endDateFilter === "") {
            dateStart = startTicketDate;
            dateEnd = endTicketDate;
        } else if (startDateFilter && endDateFilter) {
            dateStart = startDateFilter;
            dateEnd = endDateFilter; assignedTicketDownloads;
        }
        if (moment(dateStart).isBefore(dateEnd)) {
            [dateEnd, dateStart] = [dateEnd, dateStart];
        } else {
            [dateEnd, dateStart] = [dateStart, dateEnd];
        }
        selectedTab.downloadData(dateStart, dateEnd, query);
    }

    const ticketObj = {
        table: (
            <div className="d-flex flex-column ">
                <div className="shadow">
                    <NewTicketsTable
                        data={selectedTab?.ticketData?.data}
                        isLoading={selectedTab?.loading}
                        refresh={refresh}
                        setRefresh={setRefresh}
                        totalPage={totalPage}
                        setNewPage={setNewPage}
                        handleSort={handleSort}
                        newPage={newPage}
                    />
                </div>
            </div>
        ),
        graph: (
            <div className="w-50">
                <ChartOptions
                    data={selectedTab?.ticketData?.data}
                    loading={selectedTab?.loading}
                />
            </div>
        ),
    };

    return (
        <>
            <div className="mt-2">
                <div className="d-flex justify-content-between flex-wrap">
                    <div className="d-flex flex-wrap gap-5">
                        <TicketsOverall
                            ticketData={selectedTab?.statsData}
                            isLoading={selectedTab?.loading}
                            error={selectedTab?.error}
                        />
                        <TicketsToday
                            ticketData={selectedTab?.statsData}
                            isLoading={selectedTab?.loading}
                            error={selectedTab?.error}
                        />
                    </div>
                    <div className="" style={{ height: "10rem" }}>
                        <div className="">
                            <div className="d-flex gap-2 me-n2">
                                <div className="d-flex flex-column">
                                    <InputData
                                        setStartDateFilter={setStartDateFilter}
                                        setEndDateFilter={setEndDateFilter}
                                        downloadStatsData={ticketData}
                                        handleDownload={handleDownload}
                                    />
                                </div>
                                {tab !== 'internalTickets' && <div className="mt-1">
                                    <DateFilter
                                        tab={tab}
                                        refresh={refresh}
                                        rowChecked={rowChecked}
                                        setRefresh={setRefresh}
                                        selectedStatus={selectedStatus}
                                        selectedCategory={selectedCategory}
                                        selectedPriority={selectedPriority}
                                        selectedAssignee={selectedAssignee}
                                        doctorCallAttempt={doctorCallAttempt}
                                        setSelectedStatus={setSelectedStatus}
                                        handleFilterClick={handleFilterClick}
                                        setSelectedCategory={setSelectedCategory}
                                        setSelectedPriority={setSelectedPriority}
                                        setSelectedAssignee={setSelectedAssignee}
                                        selectedSubCategory={selectedSubCategory}
                                        assigneeOptions={allTicketStats?.assignee}
                                        setDoctorCallAttempt={setDoctorCallAttempt}
                                        setSelectedSubCategory={setSelectedSubCategory}
                                        data={selectedTab?.ticketData?.data || selectedTab?.ticketData?.tickets}
                                    />
                                </div>}
                            </div>
                            <div className="mt-2">
                                <AllInputSearch
                                    handleChange={handleChange}
                                    handleSearch={handleSearch}
                                />
                            </div>
                        </div>
                    </div>
                </div>
                <div className="mt-2">
                    <CardTabs components={ticketObj} />
                </div>
            </div>
        </>
    );
};

export default TicketTab;
